// Safari mobile SVG fix
function fixSafariSVGs() {
  var brandContainer = document.querySelector('[data-brand-wall]');
  if (brandContainer) {
    // Force complete DOM refresh for Safari mobile
    var html = brandContainer.innerHTML;
    brandContainer.innerHTML = '';
    setTimeout(function() {
      brandContainer.innerHTML = html;
    }, 10);
  }
}

// Multiple event listeners for Safari mobile
window.addEventListener('pageshow', function(event) {
  if (event.persisted) {
    fixSafariSVGs();
  }
});
window.addEventListener('focus', function() {
  setTimeout(fixSafariSVGs, 100);
});
document.addEventListener('DOMContentLoaded', function() {
  setTimeout(fixSafariSVGs, 200);
});

// Safari mobile specific fix - force immediate re-render
if (/Safari/.test(navigator.userAgent) && /Mobile/.test(navigator.userAgent)) {
  setTimeout(function() {
    var wall = document.getElementById('brand-wall-{{ section.id }}');
    if (wall) wall.style.display = 'none';
    setTimeout(function() {
      if (wall) wall.style.display = '';
    }, 1);
  }, 50);
}